import ArrowRightIcon from "@8x8/oxygen-icon/icons/ArrowRightIcon";
import { COLORS } from "@/react/theme/constants";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 24px;
`;

export const LinkedHeader = styled.div`
  cursor: pointer;
`;

const BreadcrumbsHeader = ({ trunkGatewayName }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToTrunks = () => {
    const pathSegments = location.pathname.split("/");
    const newPath = pathSegments.slice(0, -1).join("/") || "/";
    navigate(newPath);
  };

  return (
    <HeaderContainer>
      <LinkedHeader onClick={navigateToTrunks}>Trunk Gateways</LinkedHeader>
      <ArrowRightIcon color={COLORS.secondary} size={18} />
      <div>{trunkGatewayName}</div>
    </HeaderContainer>
  );
};

export default BreadcrumbsHeader;
